import React from 'react';
import WidgetsIcon from '@material-ui/icons/Widgets';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import { Route, Switch } from 'react-router-dom';
import { ListItemLink } from '../../../components/sidebar-list-item-link';
import DashboardContainer from './dashboard/dashboard';
import PickupRequests from './pickup_requests';
import ParcelContainer from './parcel';
import BookParcel from './parcel/createParcel';
import EditParcel from './parcel/editParcel';
import ViewParcel from './parcel/viewParcel';
import Payment from './payments/index';
import PaymentRequest from './payments/paymentRequest';
import PaymentShow from './payments/invoice';
import ChangePassword from './change_password';
import ProfilePage from './profile/index';
import TimelineIcon from '@material-ui/icons/Timeline';
import LockIcon from '@material-ui/icons/Lock';
import PaymentIcon from '@material-ui/icons/Payment';
import AddIcon from '@material-ui/icons/Add';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import PersonIcon from '@material-ui/icons/Person';

const routeList: Array<{ to: string; component?: any; icon?: any; primary: string }> = [
  { to: '/dashboard', primary: 'Dashboard', icon: TimelineIcon, component: DashboardContainer },
  { to: '/dashboard/parcel/create', primary: 'Add Parcel', icon: AddIcon, component: BookParcel },
  { to: '/dashboard/parcel', primary: 'Parcels', icon: WidgetsIcon, component: ParcelContainer },
  { to: '/dashboard/parcel/edit/:id', primary: 'Parcels', component: EditParcel },
  { to: '/dashboard/parcel/view/:id', primary: 'Parcels', component: ViewParcel },
  { to: '/dashboard/paymentshow/:id', primary: 'Payment show', component: PaymentShow },
  { to: '/dashboard/pickup-requests', primary: 'Pickup Requests', icon: DirectionsBikeIcon, component: PickupRequests },
  { to: '/dashboard/payment', primary: 'Payments', icon: AccountBalanceIcon, component: Payment },
  { to: '/dashboard/payment/request', primary: 'Payment Request', icon: PaymentIcon, component: PaymentRequest },
  { to: '/dashboard/profile', primary: 'Profile', icon: PersonIcon, component: ProfilePage },
  { to: '/dashboard/change_password', primary: 'Change Password', icon: LockIcon, component: ChangePassword },
];

export const sidebar = (
  <div>
    {routeList
      .filter((item) => item.icon)
      .map((item, index) => (
        <ListItemLink key={index} to={item.to} primary={item.primary} icon={item.icon} />
      ))}
  </div>
);

export const routeContainer = () => (
  <Switch>
    {routeList
      .filter((item) => item.component)
      .map((item, index) => (
        <Route key={index} exact path={item.to} component={item.component} />
      ))}
  </Switch>
);
